import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

// The app restores list positions itself, per screen. Left on 'auto' the
// browser also restores a position on a back navigation, asynchronously and
// against a page React has not finished rendering yet, which fights it.
if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
